// The top bar the classic Reports pages share: the period as one select, and one Export menu.
import type { IconName } from '../ui/icons'
import { useStaffText } from '../ui/StaffText'
import { PERIODS, periodRange, type PeriodId } from './insightCalc'
import { ActionMenu, Pick, RangePick } from './kit'
import { periodDates } from './questions'

export function PeriodMenu({
  period,
  onPeriod,
  custom,
  onCustom,
  today,
  bad,
  flash = 0,
}: {
  period: PeriodId
  onPeriod: (p: PeriodId) => void
  custom: [string, string]
  onCustom: (c: [string, string]) => void
  today: string
  /** The custom dates do not make a period: the range is marked. */
  bad: boolean
  /** Bumped when a question sets its own period, so the change is seen. */
  flash?: number
}) {
  const { lang, say } = useStaffText()
  const [from, to] = periodRange(period, today, custom)
  const dates = period === 'custom' ? '' : periodDates(from, to, lang, today)
  return (
    <span className="rp-period">
      <Pick
        key={flash}
        className={flash > 0 ? 'rp-flash' : undefined}
        label={say('insight.period')}
        caption={say('insight.period')}
        suffix={dates || undefined}
        value={period}
        onChange={(k) => {
          if (k === 'custom' && period !== 'custom') onCustom([from, to])
          onPeriod(k as PeriodId)
        }}
        options={PERIODS.map(([k, l]) => ({ value: k, label: say(l) }))}
      />
      {period === 'custom' && <RangePick label={say('insight.dates')} from={custom[0]} to={custom[1]} max={today} isInvalid={bad} onChange={(f, t) => onCustom([f, t])} />}
    </span>
  )
}

export type ExportItem = { label: string; icon?: IconName; href?: string; run?: () => void; disabled?: boolean } | 'rule'

/** One Export menu: the files, and the reports by email. A link is followed, an action run. */
export function ExportMenu({ items }: { items: ExportItem[] }) {
  const { say } = useStaffText()
  return (
    <ActionMenu
      label={say('insight.export')}
      text={say('insight.export')}
      icon="download"
      items={items.map((m, i) =>
        m === 'rule'
          ? 'rule'
          : {
              id: String(i),
              label: m.label,
              icon: m.icon,
              disabled: m.disabled || (!m.href && !m.run),
              run: () => (m.href ? window.location.assign(m.href) : m.run?.()),
            },
      )}
    />
  )
}
